/* eslint-disable camelcase, no-undef */

(function () {
  if (typeof window !== 'undefined' && window.TYPO3_ASSET_BASE) {
    __webpack_public_path__ = window.TYPO3_ASSET_BASE; // set from TYPO3
  } else if (document.currentScript) {
    __webpack_public_path__ = document.currentScript.src.replace(/[^/]+$/, '');
  } else {
    __webpack_public_path__ = '/typo3temp/assets/compressed/';
  }
})();
